import {translate} from 'vue-gettext';
const {gettext: $gettext} = translate;


export default {

  // gets the translated description for a factor.  this helper function
  // avoids us trying to translate user-defined strings.
  getTranslatedFactorDesc(factor) {
    if (factor && factor.type) {
      // custom factor type, no translation just use what we have.
      if (factor.type === 'custom_app' || factor.type === 'device')  {
        return factor.description
      }
      // built-in factor type, should have a translation for it.
      else {
        return $gettext(factor.description)
      }
    }
    else {
      return ""
    }
  },
  // gets the specified attribute from the factor profile.
  getFactorProfileAttribute(factor, attrName) {
    let profile_attr = null
    if (factor && factor.profile) {
      if (attrName in factor.profile) {
        profile_attr = factor.profile[attrName]
      }
    }
    return profile_attr;
  },
  getTranslatedConfigID(id) {
    if (id) {
      return $gettext(`cfg.${id}`);
    }
    else {
      return '';
    }

  },
  getTranslatedCategoryID(id) {
    if (id) {
      // the category id is prefixed with NN_ which we need to strip off.
      let rawCategoryId = id.slice(3);
      return $gettext(`cfg.${rawCategoryId}`);
    }
    else {
      return '';
    }

  },
  getTranslatedConfigDesc(id) {
    if (id) {
      const descTag = `cfg.${id}.desc`
      let translatedDescription = $gettext(descTag);
      // if we don't have a translation, then return null.
      if (translatedDescription == descTag) {
        return null;
      }
      return translatedDescription;
    }
    else {
      return null;
    }

  },
  getTranslatedConfigField(id, field) {
    if (id && field) {
      const fieldTag = `cfg.${id}.field.${field}`
      let translatedField = $gettext(fieldTag);
      return translatedField;
    }
    else {
      return null;
    }
  }
}
